import React, { useEffect, useState } from 'react'

import { Select } from 'antd';

import './styles.css';
import { Notifiable, Notifications } from '@app/types/core.types';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { initial, isArray } from 'lodash';
import { Visibility } from './Visibility';

interface IInputTagProps {
    buttonText: string;
    sizeTextTag?: number;
    validate?: (value: string[]) => Notifiable;
    visible?: boolean;
    onChange: (value: string[]) => void;
    initialValues?: string[];
}

export const InputTag = ({
    buttonText,
    validate,
    visible = true,
    onChange,
    initialValues
}: IInputTagProps) => {

    const [errors, setErrors] = useState<Notifications[]>([]);

    const [listInput, setListInput] = useState<string[]>([]);

    useEffect(() => {
        if(initialValues && initialValues.length > 0){
            setListInput([...initialValues]);
        } 
    },[initialValues]);

    const handleSelectChange = (values: string[]) => {
        setErrors([]);
        let newTags: string[] = [...values];

        if (isArray(values)) {
            if (isObjNotEmpty(validate)) {
                const notifiable: Notifiable = validate && validate(newTags) || { valid: true };
                if (notifiable.valid) {
                    setListInput(newTags);
                } else {
                    setErrors(notifiable.notifications || []);
                }
                return;
            }
        }

        setListInput(newTags);
    };

    useEffect(() => {
        onChange && onChange(listInput);
    }, [listInput]);

    return (
        <Visibility
            visible={visible}
        >
            <Select
                showSearch
                mode="tags"
                style={{ width: "100%" }}
                placeholder={buttonText || "Adicionar tags"}
                onChange={handleSelectChange}
                value={listInput}
                onFocus={() => {
                    setErrors([]);
                }}
            />
            {
                errors.map((error) => (
                    <span className="txt-danger">{error.message}</span>
                ))
            }
        </Visibility>
    )
}
